


import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Footer from "./Footer";
import { FiEdit2 } from "react-icons/fi";
import { FiArrowRight, FiChevronUp } from "react-icons/fi";
// import axios from "axios";
const pickOfTheDay = {
  brandName: "Strch",
  logo: "/assets/images/brands/strch-logo.png",
  offerText: "Find Best Deals of Strch on [YourSite] Upto 50% Off on Selected Products + Flat 30% Cashback on all Strch Orders",
  redirectPath: "/stores/strch-coupons",
};

const howItWorksSteps = [
  {
    id: 1,
    icon: "/assets/images/logo/step1.png",
    title: "Visit [YourSite] app first",
    desc: "before you shop online",
  },
  {
    id: 2,
    icon: "/assets/images/logo/step2.png",
    title: "Select the brand you want to shop on",
    desc: "and you will be re-directed to their site/app",
  },
  {
    id: 3,
    icon: "/assets/images/logo/step3.png",
    title: "Shop & pay as usual on the site",
    desc: "you are shopping normally, no difference",
  },
  {
    id: 4,
    icon: "/assets/images/logo/step4.png",
    title: "Get Cashback on your order",
    desc: "in your [YourSite] account",
  },
  {
    id: 5,
    icon: "/assets/images/logo/step5.png",
    title: "Transfer your Cashback",
    desc: "to your Bank, UPI or take as Amazon pay balance / Flipkart gift cards",
  },
];
const GiveFeedback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const topic = searchParams.get("topic") || "general";

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    message: "",
    file: null,
    captcha: "",
  });

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    // 👉 Yaha aapka asli auth-check lagega — jaise ye ho sakta hai:
    // const userData = JSON.parse(localStorage.getItem("userData"));
    // ya kisi Context/Redux se aa raha ho

    const userData = JSON.parse(localStorage.getItem("userData")); // 👈 apne project ke hisaab se badal lena

    if (userData && userData.fullName && userData.email) {
      setForm((prev) => ({
        ...prev,
        fullName: userData.fullName,
        email: userData.email,
      }));
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setShowScrollTop(window.scrollY > 300);
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 👉 Baad me yaha API call lagegi, FormData ke saath (file bhi jayega):
    // const fd = new FormData();
    // fd.append("fullName", form.fullName);
    // fd.append("email", form.email);
    // fd.append("message", form.message);
    // fd.append("topic", topic);
    // if (form.file) fd.append("file", form.file);
    //
    // axios.post(`${process.env.REACT_APP_API}website/submit_feedback`, fd)
    //   .then(() => alert("Feedback submitted!"))
    //   .catch(() => alert("Something went wrong"));

    console.log("Form submitted:", { ...form, topic });
  };

  // const scrollToTop = () => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // };

  return (
    <>
      <nav className="fb-breadcrumb">
        <div className="container">
          <span onClick={() => navigate("/")}>Home</span> / <b>Contact Us</b>
        </div>
      </nav>

      <section className="fb-section">
        <div className="container fb-layout">
          <div className="fb-form-box">
            <h2>Say Hello!</h2>
            <p>
              Please elaborate your concern in the below, Our support team
              will endeavour to get back to you within 48 hours
            </p>

            <form onSubmit={handleSubmit}>
              <div className="fb-row">
                <div className="fb-field">
                  <label>Full name</label>
                  <div className="fb-input-wrap">
                    <input
                      type="text"
                      name="fullName"
                      value={form.fullName}
                      onChange={handleChange}
                      required
                    />
                    {isLoggedIn && (
                      <FiEdit2 className="fb-edit-icon" size={16} />
                    )}
                  </div>
                </div>
                <div className="fb-field">
                  <label>Email address</label>
                  <div className="fb-input-wrap">
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                    {isLoggedIn && (
                      <FiEdit2 className="fb-edit-icon" size={16} />
                    )}
                  </div>
                </div>
              </div>

              <div className="fb-field">
                <label>Your Message</label>
                <textarea
                  name="message"
                  rows="5"
                  value={form.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <div className="fb-file-field">
                <label className="fb-choose-file">
                  Choose File
                  <FiArrowRight size={16} />
                  <input type="file" onChange={handleFileChange} hidden />
                </label>
                <p className="fb-file-note">
                  Allowed file types are: .jpg, .pdf, .png, .jpeg <br />
                  Allowed size: 2MB
                </p>
                {form.file && <p className="fb-file-name">{form.file.name}</p>}
              </div>

              <div className="fb-field fb-captcha-field">
                <div className="fb-captcha-box">CAPTCHA</div>
                <input
                  type="text"
                  name="captcha"
                  placeholder="Enter captcha shown"
                  value={form.captcha}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="fb-submit-btn">
                Submit
              </button>
            </form>
          </div>

           <div className="fb-sidebar">
            {/* 👉 Pick of the Day - clickable card, product/API se aayega */}
            <div
              className="fb-pick-of-day"
              onClick={() => navigate(pickOfTheDay.redirectPath)}
            >
              <p className="fb-pick-label">Pick of the Day</p>
              <div className="fb-pick-card">
                <img
                  src={pickOfTheDay.logo}
                  alt={pickOfTheDay.brandName}
                  className="fb-pick-logo"
                />
                <p className="fb-pick-text">{pickOfTheDay.offerText}</p>
              </div>
            </div>

            <div className="fb-how-it-works">
              <h4>How [YourSite] Works?</h4>
              {howItWorksSteps.map((step) => (
                <div className="fb-step" key={step.id}>
                  <img src={step.icon} alt={step.title} className="fb-step-icon" />
                  <div>
                    <p className="fb-step-title">{step.title}</p>
                    <p className="fb-step-desc">{step.desc}</p>
                  </div>
                </div>
              ))}

              <span className="fb-learn-more" onClick={() => navigate("/how-it-works")}>
                Learn More <FiArrowRight size={14} />
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* {showScrollTop && (
        <button className="fb-scroll-top" onClick={scrollToTop} aria-label="Scroll to top">
          <FiChevronUp size={22} />
        </button>
      )} */}

      <Footer />
 <style jsx>{`
        .fb-breadcrumb {
          padding: 12px 0;
          font-size: 0.9rem;
          color: var(--dark-text);
        }
        .fb-breadcrumb span {
          cursor: pointer;
          color: var(--primary);
        }
        .fb-section {
          padding: 1rem 0 4rem;
          
        }
        .fb-layout {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 1.5rem;
        }
        .fb-form-box {
          border: 1px solid #eee;
          border-radius: 12px;
          padding: 2rem;
        }
        .fb-form-box h2 {
          margin-bottom: 0.5rem;
          color: var(--dark-text);
        }
        .fb-form-box p {
          color: #777;
          margin-bottom: 1.5rem;
        }
        .fb-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        .fb-field {
          margin-bottom: 1.2rem;
        }
        .fb-field label {
          display: block;
          font-size: 0.85rem;
          color: #555;
          margin-bottom: 4px;
        }
        .fb-field textarea {
          width: 100%;
          padding: 0.6rem 0.8rem;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 0.9rem;
          color: var(--dark-text);
        }
        .fb-input-wrap {
          position: relative;
          display: flex;
          align-items: center;
        }
        .fb-input-wrap input {
          width: 100%;
          padding: 0.6rem 2.2rem 0.6rem 0.8rem;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 0.9rem;
          color: var(--dark-text);
        }
        .fb-edit-icon {
          position: absolute;
          right: 12px;
          color: var(--primary);
          pointer-events: none;
        }
        .fb-choose-file {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          border: 1px solid var(--primary);
          color: var(--primary);
          padding: 0.5rem 1.2rem;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
        }
        .fb-file-note {
          font-size: 0.75rem;
          color: #999;
          margin-top: 0.4rem;
        }
        .fb-file-name {
          font-size: 0.8rem;
          color: var(--dark-text);
          margin-top: 0.3rem;
        }
        .fb-captcha-field {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        .fb-captcha-box {
          border: 1px solid #ddd;
          border-radius: 6px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          letter-spacing: 3px;
          background: #f5f5f5;
          color: var(--dark-text);
        }
        .fb-captcha-field input {
          flex: 1;
          padding: 0.6rem 0.8rem;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 0.9rem;
        }
        .fb-submit-btn {
          background: var(--primary-gradient);
          color: #fff;
          border: none;
          padding: 0.7rem 2.5rem;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 0.5rem;
        }
        .fb-submit-btn:hover {
          opacity: 0.9;
        }

        .fb-sidebar {
          display: flex;
          flex-direction: column;
          gap: 1.2rem;
        }

        .fb-pick-of-day {
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          background: var(--primary-gradient);
          transition: transform 0.2s ease;
        }
        .fb-pick-of-day:hover {
          transform: translateY(-2px);
        }
        .fb-pick-label {
          color: #fff;
          font-weight: 700;
          text-align: center;
          padding: 0.8rem;
          margin: 0;
        }
        .fb-pick-card {
          background: #fff;
          margin: 0 0.8rem 0.8rem;
          border-radius: 8px;
          padding: 1.2rem;
          text-align: center;
        }
        .fb-pick-logo {
          max-width: 100px;
          max-height: 40px;
          object-fit: contain;
          margin-bottom: 0.8rem;
        }
        .fb-pick-text {
          font-size: 0.85rem;
          font-style: italic;
          color: var(--dark-text);
          margin: 0;
        }

        .fb-how-it-works {
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 1.2rem;
        }
        .fb-how-it-works h4 {
          color: var(--dark-text);
          margin-bottom: 0.5rem;
        }
        .fb-step {
          display: flex;
          gap: 0.8rem;
          margin-top: 1rem;
          align-items: flex-start;
        }
        .fb-step-icon {
          width: 52px;
          height: 52px;
          object-fit: contain;
          flex-shrink: 0;
          border-radius: 50%;
        }
        .fb-step-title {
          margin: 0;
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--dark-text);
        }
        .fb-step-desc {
          margin: 2px 0 0;
          font-size: 0.85rem;
          color: #666;
        }
        .fb-learn-more {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          color: var(--primary);
          font-weight: 600;
          cursor: pointer;
          margin-top: 1.2rem;
          font-size: 0.9rem;
        }

        .fb-scroll-top {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: var(--primary-gradient);
          color: #fff;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          z-index: 999;
        }

        @media (max-width: 900px) {
          .fb-layout {
            grid-template-columns: 1fr;
          }
          .fb-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      {/* style block pehle jaisa hi rahega */}
    </>
  );
};

export default GiveFeedback;